
<template>
  <div v-show="showNotification && notifications.length" class="bto-sb-betslip-notification" ref="betslipNotification">
    <div class="bto-sb-notification-result" :style="styleObject">
      <div class="bto-sb-notification-wrapper">
        <div class="bto-sb-notification-title">
          <h3>{{ t('Notifications.Title') }} - {{ notifications.length }}</h3>
          <a href="#" :title="`${t('W.clearA')}`" @click.prevent="markAsReadAllNotifications()"></a>
        </div>
        <div class="bto-sb-notification-content" v-for="(groupedNotifications, groupedNotificationsIndex) in  groupedByDate(notifications)" :key="groupedNotificationsIndex">
          <div class="bto-sb-notification-innercontent">
            <div class="bto-sb-notification-innertitle">
              <h3> {{ groupedNotifications.date }}</h3>
            </div>
            <ul>
              <li v-for="(notificationData, notifyDataIdx) in groupedNotifications.notifications" :key="notifyDataIdx">
                {{ notificationData.msg }}
                <a href="#" title="Clear" @click.prevent="markAsReadSingleNotification(notificationData.id)"></a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { EventBus } from '../../../../../services/event-bus-service';
  import NotificationsService from '../../../../../services/betslip/betslip-notifications-service';
  import LocalStorageService from '../../../../../services/storage/local-storage-service';

  export default {
    name: 'NotificationResult',
    data() {
      return {
        notifications: [],
        notifies: [],
        styleObject: {
          opacity: 1,
          visibility: 'hidden'
        },
        notificationsService: new NotificationsService(),
        showNotification: false,
      };
    },
    watch: {
      showNotification(val) {
        if (val) {
          document.addEventListener('mouseup', this.toggleNotification);
        } else {
          document.removeEventListener('mouseup', this.toggleNotification);
        }
      },
    },
    created() {
      this.notifies = LocalStorageService.get('notifications');
    },
    mounted() {
      if (this.notifies) {
        this.notifies.forEach((notify) => {
          this.notifications.push(notify);
        });
      }
      EventBus.$on('notificationResults', (notifies) => {
        if (this.showNotification) {
          this.styleObject.visibility = 'hidden';
          this.showNotification = false;
        } else {
          this.styleObject.visibility = 'visible';
          this.notifications = notifies;
          this.showNotification = true;
        }
      });
      EventBus.$on('emitterOnNotifications', () => {
        this.notifications = LocalStorageService.get('notifications');
      });
    },
    methods: {
      toggleNotification(e) {
        const el = this.$refs.betslipNotification;
        if (!(el == e.target || el.contains(e.target))) {
          this.showNotification = false;
        } else {
          this.showNotification = true;
        }
      },
      readNotifications(notifyId) {
        if (notifyId) {
          this.notifications.splice(this.notifications.findIndex(m => m.id === notifyId), 1);
        } else {
          this.notifications = [];
        }
        LocalStorageService.set('notifications', this.notifications);
        EventBus.$emit('makeasreadnotify', this.notifications);
      },
      markAsReadSingleNotification(notifyId) {
        this.notificationsService.getParams.id = notifyId;
        this.notificationsService.execute(() => {
          this.readNotifications(notifyId);
        });
      },
      markAsReadAllNotifications() {
        this.notificationsService.execute(() => {
          this.readNotifications(null);
        });
      },
      groupedByDate(list) {
        const result = [];
        if (list && list.length) {
          list.forEach(function (hash) {
            return function (a) {
              if (!hash[a.t.DatePart]) {
                hash[a.t.DatePart] = { date: a.t.DatePart, notifications: [] };
                result.push(hash[a.t.DatePart]);
              }
              hash[a.t.DatePart].notifications.push({ id: a.id, msg: a.msg });
            };
          }(Object.create(null)));

          return result;
        }
      }
    },
  };
</script>
